import { render } from "./SalesList.vue?vue&type=template&id=6844e87a&scoped=true"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"

import "./SalesList.vue?vue&type=style&index=0&id=6844e87a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6844e87a"]])

export default __exports__